import { Dialog, DialogType } from '../../../../src/feature/narrator/narrator.model';

export const dialog: Dialog[] = [
  {
    id: 'start',
    type: DialogType.description,
    text: 'The hunter stands by the lodge, a bow across his back. He watches the treeline, then gives you a short nod.',
    options: [
      { text: 'Greet him.', nextDialogId: 'greet' },
      { text: 'Watch the woods with him.', nextDialogId: 'watch' },
    ],
  },
  {
    id: 'greet',
    type: DialogType.dialog,
    text: 'Game, or rest? The woods keep me. I keep to the woods.',
    options: [
      { text: 'What do you hunt?', nextDialogId: 'game' },
      { text: 'You live out here alone?', nextDialogId: 'alone' },
    ],
  },
  {
    id: 'game',
    type: DialogType.dialog,
    text: 'Deer, boar, hare. Whatever the season gives. The bow does not ask questions.',
    options: [
      { text: 'Any luck lately?', nextDialogId: 'luck' },
      { text: 'Good hunting, then.', nextDialogId: 'bye' },
    ],
  },
  {
    id: 'luck',
    type: DialogType.dialog,
    text: 'A boar, two days back. He led me half a morning before he tired. A fair fight.',
    options: [{ text: 'Well earned.', nextDialogId: 'bye' }],
  },
  {
    id: 'alone',
    type: DialogType.dialog,
    text: 'Alone suits me. Men are louder than boar, and harder to read.',
    options: [{ text: 'Fair enough.', nextDialogId: 'bye' }],
  },
  {
    id: 'watch',
    type: DialogType.description,
    text: 'He does not speak. His eyes move along the trees, reading what you cannot. After a while he points at a broken branch, then lets his hand fall.',
    options: [
      { text: 'Ask what he sees.', nextDialogId: 'game' },
      { text: 'Leave him to it.', nextDialogId: 'start' },
    ],
  },
  {
    id: 'bye',
    type: DialogType.dialog,
    text: 'Keep to the path, traveller. The woods are no place to wander.',
    options: [{ text: 'I will.', nextDialogId: 'start' }],
  },
];
